// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationNameDto
 */
export interface IOrganizationNameDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationNameDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationNameDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationNameDto
     */
    path?: string;
}

/**
 * Check if a given object implements the IOrganizationNameDto interface.
 */
export function instanceOfIOrganizationNameDto(value: object): value is IOrganizationNameDto {
    return true;
}

export function IOrganizationNameDtoFromJSON(json: any): IOrganizationNameDto {
    return IOrganizationNameDtoFromJSONTyped(json, false);
}

export function IOrganizationNameDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationNameDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
    };
}

export function IOrganizationNameDtoToJSON(json: any): IOrganizationNameDto {
    return IOrganizationNameDtoToJSONTyped(json, false);
}

export function IOrganizationNameDtoToJSONTyped(value?: IOrganizationNameDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'path': value['path'],
    };
}

